export default "##### Drive Time (Trade Area)\n---\n- Visualize the trade area by how long it would take someone to drive to or from the property\n";